import { useRef } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PRODUCTS_STATUS_QUERY_KEY } from '@/apiHooks/queryKeys';
import type { AdacApplicationForm, AdacApplicationStatus } from '@/api/adac/adacApplication';
import { submitAdacApplication } from '@/api/adac/adacApplication';
import { getApiErrorCode } from '@/utils/apiErrorMapper.util';

export const useSubmitAdacApplication = (
  onSuccess: (application: AdacApplicationStatus) => void,
  onError: (code?: string) => void,
) => {
  const queryClient = useQueryClient();
  const pendingSubmission = useRef(false);
  const { mutate, isLoading } = useMutation(submitAdacApplication, {
    retry: false,
    onSuccess: (application) => {
      queryClient.invalidateQueries(PRODUCTS_STATUS_QUERY_KEY);
      onSuccess(application);
    },
    onError: (error) => onError(getApiErrorCode(error)),
    onSettled: () => {
      pendingSubmission.current = false;
    },
  });

  return {
    isSubmitting: isLoading,
    submitApplication: (form: AdacApplicationForm) => {
      if (pendingSubmission.current) return;
      pendingSubmission.current = true;
      mutate(form);
    },
  };
};
